import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	emptyAttributesHidden: {
		id: 'servicedesk-insight-editable-attribute-list.empty-attributes-information.empty-attributes-hidden',
		defaultMessage: 'Empty attributes hidden',
		description:
			'Text to explain that there are attributes on the current object that have been hidden because they have no values',
	},
	show: {
		id: 'servicedesk-insight-editable-attribute-list.empty-attributes-information.show',
		defaultMessage: 'Show',
		description:
			'Text on a button that, when clicked, will show/display attributes that had been hidden because they were empty',
	},
});
